import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EventsGrid from "@/components/EventsGrid";
import WatchAndPrivate from "@/components/HomePanels";
import ThreeBand from "@/components/ThreeBand";
import Packages, { packageLabel } from "@/components/Packages";
import About from "@/components/About";
import Members from "@/components/Members";
import Glimpses from "@/components/Glimpses";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";

export default function Home() {
  const lenisRef = useRef(null);
  const [preselectedPackage, setPreselectedPackage] = useState("");
  const [preselectedCity, setPreselectedCity] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const scrollTo = (id) => {
    if (lenisRef.current) lenisRef.current.scrollTo(id, { offset: -84 });
  };

  return (
    <div className="bg-ink text-bone font-sans min-h-screen" data-testid="home-page">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav scrollTo={scrollTo} />
      <Hero />
      <EventsGrid />
      <WatchAndPrivate />
      <Packages onReserve={(pkg) => { setPreselectedPackage(packageLabel(pkg)); setPreselectedCity(pkg.group === "Within Hyderabad" ? "Hyderabad" : ""); scrollTo("#enquire"); }} />
      <ThreeBand />
      <About />
      <Members />
      <Glimpses />
      <Enquiry preselectedPackage={preselectedPackage} preselectedCity={preselectedCity} />
      <Footer scrollTo={scrollTo} />
    </div>
  );
}
